import React, {Component} from 'react';
import {connect} from 'react-redux';
import actions from './search.actions';
import {Tabs} from '../widgets';

class SearchCategoryTabs extends Component {
	render() {
		if (this.props.isMobile) return null;

		return (
			<Tabs
				items={[
					{
						link: '/search-category/',
						icon: 'icon-face',
						label: 'Provider',
						current: this.props.searchFor === 'provider',
						onClick: () => this.props.setSearchFor('provider'),
						key: 0
					},
					{
						link: '/search-category/',
						icon: 'icon-people',
						label: 'Community',
						current: this.props.searchFor === 'community',
						onClick: () => this.props.setSearchFor('community'),
						key: 1
					},
					{
						link: '/search-category/',
						icon: 'icon-person',
						label: 'User',
						current: this.props.searchFor === 'user',
						onClick: () => this.props.setSearchFor('user'),
						key: 2
					}
				]}
			/>
		);
	}
}

export default connect(
	state => ({
		searchFor: state.search.searchFor,
		isMobile: state.ui.screenSize === 'mobile'
	}),
	dispatch => ({
		setSearchFor: searchFor => {
			dispatch(actions.searchFor(searchFor));
		}
	})
)(SearchCategoryTabs);



// WEBPACK FOOTER //
// ./src/search/SearchCategoryTabs.js